import React from 'react';

const ChipActivity = (props) => {
  return (
    <div className='relative mb-4 w-max '>
      <div
        className={`flex items-center h-8 px-4 py-1 text-lg font-normal rounded-3xl  bg-chart-${props.element} ${props.element === 'lyingOnStomach' ? 'text-chip' : 'text-white'}`}
      >
        {props.lable}
      </div>
    </div>
  );
};

export default ChipActivity;
